/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityPhysicianInput
 */
export interface FacilityPhysicianInput {
    /**
     * 
     * @type {string}
     * @memberof FacilityPhysicianInput
     */
    physician_name: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityPhysicianInput
     */
    physician_npi: string;
    /**
     * 
     * @type {boolean}
     * @memberof FacilityPhysicianInput
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the FacilityPhysicianInput interface.
 */
export function instanceOfFacilityPhysicianInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "physician_name" in value;
    isInstance = isInstance && "physician_npi" in value;

    return isInstance;
}

export function FacilityPhysicianInputFromJSON(json: any): FacilityPhysicianInput {
    return FacilityPhysicianInputFromJSONTyped(json, false);
}

export function FacilityPhysicianInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPhysicianInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'physician_name': json['physician_name'],
        'physician_npi': json['physician_npi'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
    };
}

export function FacilityPhysicianInputToJSON(value?: FacilityPhysicianInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physician_name': value.physician_name,
        'physician_npi': value.physician_npi,
        'is_default': value.is_default,
    };
}

